"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Learner/components/Course/components/CourseSummary.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Schedules_template = require("../../../../../../components/Schedules.marko"),
    Schedules_tag = marko_loadTag(Schedules_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    IssuedCertificate_template = require("../../../../../../components/IssuedCertificate.marko"),
    IssuedCertificate_tag = marko_loadTag(IssuedCertificate_template),
    WSAdapt_template = require("../../../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Bx_template = require("../../../../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Image_template = require("../../../../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "p-3"
      },
    marko_attrs1 = {
        "class": "font-large-2 text-bold-200",
        style: "line-height:1.2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("1d9d59"),
    marko_node0 = marko_createElement("br", null, "5", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "text-primary"
      },
    marko_attrs3 = {
        "class": "blue-grey-text"
      },
    marko_attrs4 = {
        "class": "list-unstyled mt-2 pr-6"
      },
    marko_node2 = marko_createElement("br", null, "29", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("hr", null, "30", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "py-25"
      },
    marko_attrs6 = {
        "class": "py-25"
      },
    marko_attrs7 = {
        "class": "py-25"
      },
    marko_node4 = marko_createElement("br", null, "21", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("hr", null, "22", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs8 = {
        "class": "font-medium-2"
      },
    marko_node6 = marko_createElement("br", null, "48", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs9 = {
        "class": "font-medium-2"
      },
    marko_node7 = marko_createElement("br", null, "53", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs10 = {
        "class": "btn btn-primary btn-lg m-25"
      };

function getStats( list, stats ){

  if( !Array.isArray( list ) ) return stats

  list.map( ({ type, duration, outlines }) => {
    switch( type ){
      case 'module': stats.modules++; break
      case 'ASSM':
      case 'ASSG': stats.tests++; break
      
      default: stats.lessons++
    }

    if( outlines ) 
      return getStats( outlines, stats )
  } )

  return stats
};

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      height: "100vh",
      class: "classroom-info position-absolute zindex-3 top-0 w-100 theme-bg",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("div", null, "2", component);

        out.be("p", marko_attrs1, "3", component);

        Locale_tag({
            text: "Congratulation"
          }, out, __component, "4");

        out.t(" ");

        out.t(GState.get("user").first_name, component);

        out.t("! ");

        out.ee();

        out.n(marko_node0, component);

        out.n(marko_node1, component);

        Locale_tag({
            renderBody: function(out) {
              out.t("You have successfully completed the");
            }
          }, out, __component, "7");

        out.ee();

        out.be("div", null, "8", component);

        out.be("h4", null, "9", component);

        out.e("span", marko_attrs2, "10", component, 1)
          .t(input.course.name, component);

        out.t(" ");

        Locale_tag({
            text: "Course"
          }, out, __component, "11");

        out.ee();

        out.be("div", marko_attrs3, "12", component);

        out.be("ul", marko_attrs4, "13", component);

        const { modules, lessons, tests } = getStats( input.course.outlines, { tests: 0, modules: 0, lessons: 0 } )

        if (modules) {
          out.be("li", marko_attrs5, "14", component);

          out.t("- ");

          out.t(modules, component);

          out.t(" ");

          Locale_tag({
              text: "modules"
            }, out, __component, "15");

          out.ee();
        }

        if (lessons) {
          out.be("li", marko_attrs6, "16", component);

          out.t("- ");

          out.t(lessons, component);

          out.t(" ");

          Locale_tag({
              text: "lessons"
            }, out, __component, "17");

          out.ee();

          out.t(" ");
        }

        if (tests) {
          out.be("li", marko_attrs7, "18", component);

          out.t("- ");

          out.t(tests, component);

          out.t(" ");

          Locale_tag({
              text: "quizzes"
            }, out, __component, "19");

          out.ee();
        }

        out.ee();

        out.ee();

        Schedules_tag({
            list: input.dates
          }, out, __component, "20");

        out.ee();

        if (Array.isArray(input.certificates) && input.certificates.length) {
          out.n(marko_node4, component);

          out.n(marko_node5, component);

          out.be("h5", marko_attrs8, "23", component);

          Locale_tag({
              text: "Certificates"
            }, out, __component, "24");

          route_link_tag({
              href: "/achievements",
              class: "float-right",
              renderBody: function(out) {
                Locale_tag({
                    text: "View Achievements"
                  }, out, __component, "26");
              }
            }, out, __component, "25");

          out.ee();

          Row_tag({
              class: "no-gutters",
              renderBody: function(out) {
                var $for$0 = 0;

                marko_forOf(input.certificates, function(certificate, index) {
                  var $keyScope$0 = "[" + (($for$0++) + "]");

                  WSAdapt_tag({
                      ns: "col-md-2 col-6",
                      hs: "col-md-6 col-6",
                      qs: "col-md-3 col-6",
                      renderBody: function(out) {
                        IssuedCertificate_tag({
                            certificate: certificate,
                            actions: [
                                "view"
                              ]
                          }, out, __component, "28" + $keyScope$0);
                      }
                    }, out, __component, index);
                });
              }
            }, out, __component, "27");
        }

        out.n(marko_node2, component);

        out.n(marko_node3, component);

        if (input.navigation) {
          Row_tag({
              class: "m-0 no-gutters",
              col: [
                  {
                      renderBody: function(out) {
                        if (input.navigation.prev) {
                          const { id, poster, title, description } = input.navigation.prev

                          out.be("span", {
                              "class": "d-inline-flex align-items-center cursor-pointer",
                              title: description
                            }, "33", component, null, 0, {
                              onclick: __component.d("click", () => component.emit('navigate', 'started', input.navigation.prev ), false)
                            });

                          Bx_tag({
                              type: "left-arrow-alt",
                              class: "font-large-1 px-1",
                              style: "color:inherit"
                            }, out, __component, "34");

                          Row_tag({
                              class: "d-flex align-items-center",
                              col: [
                                  {
                                      class: "col-3",
                                      renderBody: function(out) {
                                        Image_tag({
                                            alt: "Image",
                                            src: poster,
                                            style: "width:50px;height:50px",
                                            class: "avatar"
                                          }, out, __component, "37");
                                      }
                                    },
                                  {
                                      renderBody: function(out) {
                                        Locale_tag({
                                            text: title,
                                            class: "font-medium-1"
                                          }, out, __component, "39");
                                      }
                                    }
                                ]
                            }, out, __component, "35");

                          out.ee();
                        }
                      }
                    },
                  {
                      class: "col text-right",
                      renderBody: function(out) {
                        if (input.navigation.next) {
                          const { id, poster, title, description } = input.navigation.next

                          out.be("span", {
                              "class": "d-inline-flex align-items-center cursor-pointer",
                              title: description
                            }, "41", component, null, 0, {
                              onclick: __component.d("click", () => component.emit('navigate', 'started', input.navigation.next ), false)
                            });

                          Row_tag({
                              class: "d-flex align-items-center",
                              col: [
                                  {
                                      class: "col-3",
                                      renderBody: function(out) {
                                        Image_tag({
                                            alt: "Image",
                                            src: poster,
                                            style: "width:50px;height:50px",
                                            class: "avatar"
                                          }, out, __component, "44");
                                      }
                                    },
                                  {
                                      renderBody: function(out) {
                                        Locale_tag({
                                            text: title,
                                            class: "font-medium-1"
                                          }, out, __component, "46");
                                      }
                                    }
                                ]
                            }, out, __component, "42");

                          Bx_tag({
                              type: "right-arrow-alt",
                              class: "font-large-1 px-1",
                              style: "color:inherit"
                            }, out, __component, "47");

                          out.ee();
                        }
                      }
                    }
                ]
            }, out, __component, "31");
        } else {
          out.n(marko_node6, component);

          out.be("p", marko_attrs9, "49", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Learning doesn't stop here. Explore more ");
              }
            }, out, __component, "50");

          route_link_tag({
              renderBody: function(out) {
                Locale_tag({
                    renderBody: function(out) {
                      out.t("course & programs");
                    }
                  }, out, __component, "52");
              }
            }, out, __component, "51");

          out.ee();

          out.n(marko_node7, component);

          route_link_tag({
              href: "/dashboard",
              class: "btn btn-secondary btn-lg m-25",
              renderBody: function(out) {
                Bx_tag({
                    type: "arrow-back",
                    class: "font-medium-5 float-left"
                  }, out, __component, "55");

                Locale_tag({
                    text: "Back to dashboard"
                  }, out, __component, "56");
              }
            }, out, __component, "54");

          out.be("button", marko_attrs10, "57", component, null, 0, {
              onclick: __component.d("click", () => component.emit('dismiss'), false)
            });

          Locale_tag({
              text: input.type == "partial" ? "Continue" : "Retake Course"
            }, out, __component, "58");

          out.ee();
        }

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
